import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { routes, nestedRoutePath } from '../../../constants/routes'
import TeamList from './list'
import CreateUser from './create'
import TeamMemberView from './view'

const TeamIndex = () => {
    return (
        <>
            <Routes>
                <Route path={nestedRoutePath(routes.appTeamIndex.path, routes.appCreateUser.path, true)} element={<CreateUser />} />
                <Route path={nestedRoutePath(routes.appTeamIndex.path, routes.appTeamMemberView.path, true)} element={<TeamMemberView />} />
                <Route index element={<TeamList />} />
            </Routes>
        </>
    )
}

export default TeamIndex
